module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0
// module chunks = 3 4